import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unlock",
  "use": "icon-unlock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-unlock\">\r\n<g id=\"icon-unlock_unlock\">\r\n\t<g>\r\n\t\t<path d=\"M22,24H2V10h3V7c0-3.9,3.1-7,7-7c2.7,0,4.2,1.2,5,2.1l-1.4,1.4C14.9,2.8,14.1,2,12,2C9.2,2,7,4.2,7,7v3h15V24z M4,22h16\r\n\t\t\tV12H4V22z M14,18h-4v-2h4V18z\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol